import { FALSE, TRUE } from "constants/primitives";
import WidgetConfig, { createWidgetConfig } from "helpers/init/WidgetConfig";
import isObject from "helpers/isObject";
import { calculateTCFBaseConsent } from "./calculateTCFBaseConsent";
import type { SavedTCFConsent } from "../TCFConsentProvider/types";
import loadLocalConsent from "helpers/consent/loadLocalConsent";
import TCFdeleteLocalTCString from "../TCFdeleteLocalTCString";
import deleteLocalConsent from "helpers/consent/deleteLocalConsent";
import loadLocalTCFConsent from "./loadLocalTCFConsent";
import useUserConsent from "hooks/useUserConsent";

const TCFshouldForceReconsent = (
  consent: SavedTCFConsent = calculateTCFBaseConsent(),
  consentTimestamp: number | null = 0,
  widgetConfig: WidgetConfig = createWidgetConfig()
) => {

  const { isForcingReconsent, setIsForcingReconsent } = useUserConsent();
  // Check if saved consent was with tcf enabled and if so, force reconsent and remove old tcf consent
  const nonTcfConsent = loadLocalConsent();

  // We check for saved tcf consent because consent and consentTimestamp variable might be empty right after consent
  const tcfSavedConsent = loadLocalTCFConsent(widgetConfig);

  if (nonTcfConsent && !tcfSavedConsent && !isForcingReconsent) {
    // If so, remove the tcf consent and force reconsent
    TCFdeleteLocalTCString(widgetConfig.bulkConsent);
    deleteLocalConsent();

    // We modify the state of default consent because only default consent is connected to the useShouldShowBanner() function
    // I did not add tcf consent to useShouldShowBanner() to not mix imports in case tcf is disabled in admin panel.
    setIsForcingReconsent(TRUE)
    return TRUE;
  }

  if (
    !isObject(consent) ||
    typeof consentTimestamp !== "number" ||
    !isObject(widgetConfig)
  ) {
    return FALSE;
  }


  // NOTE:
  // Entire 'force reconsent after some time' is disabled for TCF, since admin panel toggle reffer only to normal consent. We might need to add separate toggle for tcf
};

export default TCFshouldForceReconsent;
